/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { i18n } from '@/plugins/i18n'
import { getRouter } from '@/plugins/router'
import sentry from './sentry'
import vuetify from './vuetify'
import './deep-libs'
// Types
import type { App } from 'vue'

export function registerPlugins(app: App) {
  app.use(i18n)
  app.use(sentry)
  app.use(vuetify)

  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  app.use(getRouter())
}
